import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import {httpOptions} from '@portal-workspace/grow-ui-library';
 
import { environment } from '../../environments/environment';
import {  IndustryDivision,PayloadApiResponse,GetIndustryDivisionsFn, IndustryGroup,
   GetIndustryGroupsByDivisionCodeFn,IndustryClass,GetIndustryClassesByGroupCodeFn, GetIndustryDivisionTitleFn, GetIndustryGroupTitleFn, GetIndustryClassTitleFn} from '@portal-workspace/grow-shared-library';


const URL_GET_INDUSTRY_DIVISIONS = () => `${environment.api2Host}/api2/industry-divisions`;
const URL_GET_GROUPS = (divisionCode: string) => `${environment.api2Host}/api2/industry-groups/${divisionCode}`;
const URL_GET_CLASSES = (groupCode: string) => `${environment.api2Host}/api2/industry-classes/${groupCode}`;
const URL_GET_INDUSTRY_DIVISION_TITLE = (code: string) => `${environment.api2Host}/api2/industry-division/${code}`;
const URL_GET_INDUSTRY_GROUP_TITLE = (code: string) => `${environment.api2Host}/api2/industry-group/${code}`;
const URL_GET_INDUSTRY_CLASS_TITLE = (code: string) => `${environment.api2Host}/api2/industry-class/${code}`;


@Injectable({
  providedIn: 'root'
})


export class IndustryService {

  constructor(
    private httpClient: HttpClient,
  ) { }
 
  getIndustryDivisions = (): Observable<PayloadApiResponse<IndustryDivision[] | null>> => {
    return this.httpClient.get<PayloadApiResponse<IndustryDivision[] | null>>(URL_GET_INDUSTRY_DIVISIONS(),httpOptions());
  }

  getIndustryDivisionsFn: GetIndustryDivisionsFn = () => {
    return this.getIndustryDivisions().pipe(
      map(response => response.payload || [])
    );
  }

  getIndustryGroupsByDivisionCode = (divisionCode: string): Observable<PayloadApiResponse<IndustryGroup[] | null>> => {
   return this.httpClient.get<PayloadApiResponse<IndustryGroup[] | null>>(URL_GET_GROUPS(divisionCode), httpOptions());
  }
  getIndustryGroupsByDivisionCodeFn: GetIndustryGroupsByDivisionCodeFn = (divisionCode: string): Observable<IndustryGroup[]> => {
    return this.getIndustryGroupsByDivisionCode(divisionCode).pipe(
      map(response => response.payload || [])
    );
  }

  getIndustryClassesByGroupCode = (groupCode: string): Observable<PayloadApiResponse<IndustryClass[] | null>> => {
    return this.httpClient.get<PayloadApiResponse<IndustryClass[] | null>>(URL_GET_CLASSES(groupCode), httpOptions());
  }
  getIndustryClassesByGroupCodeFn: GetIndustryClassesByGroupCodeFn = (groupCode: string): Observable<IndustryClass[]> => {
    return this.getIndustryClassesByGroupCode(groupCode).pipe(
      map(response => response.payload || [])
    );
  }

  getIndustryDivisionTitleFn: GetIndustryDivisionTitleFn = (code: string): Observable<string | null> => {
    return this.httpClient.get<PayloadApiResponse<string | null>>(URL_GET_INDUSTRY_DIVISION_TITLE(code), httpOptions())
      .pipe(map(response => response.payload));
  }

  getIndustryGroupTitleFn: GetIndustryGroupTitleFn = (code: string): Observable<string | null> => {
    return this.httpClient.get<PayloadApiResponse<string | null>>(URL_GET_INDUSTRY_GROUP_TITLE(code), httpOptions())
      .pipe(map(response => response.payload));
  }

  getIndustryClassTitleFn: GetIndustryClassTitleFn = (code: string): Observable<string | null> => {
    return this.httpClient.get<PayloadApiResponse<string | null>>(URL_GET_INDUSTRY_CLASS_TITLE(code), httpOptions())
      .pipe(map(response => response.payload));
  }
}
